import json from '../storage/address.json'
const Address = {
  getAll: () => {
    const data = json; 
    return data
  },
  getProvince: () => {
    let data = json.map(address => {
      return address.province
    }) 
    data = data.filter((province, index, array) => array.indexOf(province) === index)
    return data
  },
  getDistrict: (province) => {
    let data = json.filter(address => {
      return address.province === province
    }).map(address => {
      return address.amphoe
    }) 
    data = data.filter((district, index, array) => array.indexOf(district) === index)
    return data
  },
  getSubDistrict: (province, district) => {
    let data = json.filter(address => {
      return address.province === province && address.amphoe === district
    }).map(address => {
      return address.district
    }) 
    data = data.filter((sub_district, index, array) => array.indexOf(sub_district) === index)
    return data
  },
  getZipCode: (province, district, sub_district) => {
    let data = json.filter(address => {
      return address.province === province && address.amphoe === district && address.district === sub_district
    }).map(address => {
      return address.zipcode
    }) 
    data = data.filter((zipcode, index, array) => array.indexOf(zipcode) === index)
    return data
  },
}

export default Address